import styled, { css } from 'styled-components'

export const Container = styled.div`
  padding: 0rem 2rem 2rem;
  .page-body {
    background-color: #F5F5F5 !important;
  }
`

export const ContainerWatch = styled.div`
  width: 100%;
`

export const Button = styled.button`
  border-radius: 8px;
  color: white;
  font-family: Work Sans;
  line-height: 19px;
  font-weight: bold;
  padding: 0.3rem 0.5rem;
  background-color: ${({ disabled, theme }) => (disabled ? '#bbbbbb' : theme.colors.blue)};
  font-size: 14px;
  width: 11rem;
`

export const WrongProductsWrapper = styled.div`
  margin-top: 3.5rem;
`

export const SubTitle = styled.span`
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 700;
  font-family: Work Sans;
`

export const SubTitleExtension = styled(SubTitle)`
  font-weight: 400;
  color: #3B3B3B;
`
export const TableTitle = styled.div<{ background?: string }>`
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  font-family: Work Sans;
  color: #3B3B3B;
  ${({ background = '#FFFFFF' }) => css`
      background: ${background};
    `}
  margin-top: 32px;
  margin-left: 4px;
  margin-right: 4px;
  padding: 8px 22px;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 2.5rem;
`

export const ContainerTruckDriver = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  height: 60%;
  gap: 3rem;
  font-size: 30px;
  font-weight: 700;
  font-family: Work Sans;
`

export const ButtonTruckDriver = styled.button<{ background?: string }>`
  border-radius: 8px;
  color: white;
  font-family: Work Sans;
  line-height: 19px;
  font-weight: bold;
  padding: 0.3rem 0.5rem;
  background-color: ${({ disabled, theme, background }) => (disabled ? '#bbbbbb' : background || theme.colors.blue)};
  font-size: 24px;
  height: 100px;
  width: 400px;
`
